import { MerkleTree } from 'merkletreejs';
import leaves from '@/domain/leaves';
import { Address, keccak256 } from 'viem';

// Generate our MerkleTree from the leaves
const tree = new MerkleTree(leaves, keccak256, { sortPairs: true });

export const generateProof = (leaf: Address) =>
  tree.getHexProof(leaf) as Address[];
